// The sidebar shows the signed-in user's OWN company logo (also for the platform owner).
import { useSelector } from 'react-redux';
import { selectCompanyLogo } from '../../Redux/slices/authSlice';
import logoMain from '../../assets/images/users/cropped-authx-logos.png';

export default function LogoMain() {
  const companyLogo = useSelector(selectCompanyLogo);
  return (
    <img
      src={companyLogo || logoMain}
      alt="Company logo"
      style={{ height: 54, maxWidth: 200, width: 'auto', objectFit: 'contain', objectPosition: 'left center', display: 'block' }}
    />
  );
}
